import { atomWithStorage, createJSONStorage } from 'jotai/utils'

const storage = createJSONStorage<boolean>(() => localStorage)
export const showChatTip = atomWithStorage<boolean>('showChatTip', true, storage, { getOnInit: true })
